// extracted by mini-css-extract-plugin
export default {"base":"DialogReportModComplete_base__t6iDh","content":"DialogReportModComplete_content__KmsZu"};